import { useAtom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

export const directionAtom = atomWithStorage<'rtl' | 'ltr'>('theme-direction', 'ltr');

/**
 * Theme State Atom that allows changing the current theme's state
 */
export const useDirection = () => useAtom(directionAtom);
